import React from "react"

function PaperAirplane({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8122 26.181C15.8122 26.181 15.3826 26.7383 15.0149 27.2156C14.9395 27.3137 14.8098 27.353 14.6924 27.313C14.575 27.273 14.4963 27.1634 14.4963 27.0395C14.4963 25.8766 14.4963 23.8131 14.4963 22.7482C14.4963 22.6327 14.5653 22.5276 14.6718 22.4825C14.7788 22.4367 14.902 22.4592 14.9859 22.5399C16.2792 23.779 19.7642 27.1189 20.8601 28.169C20.9324 28.238 21.0349 28.2651 21.1317 28.2399C21.2278 28.2154 21.3052 28.1432 21.3355 28.0477C22.1979 25.3509 26.7518 11.1075 27.7045 8.12808C27.7374 8.02423 27.709 7.91007 27.6316 7.83395C27.5535 7.75719 27.4387 7.73139 27.3355 7.76622C24.3787 8.77246 10.2636 13.574 7.62163 14.4732C7.52811 14.5048 7.45718 14.5815 7.43394 14.677C7.41011 14.7731 7.43651 14.8737 7.50425 14.9453C8.43826 15.9329 11.2067 18.8594 11.9297 19.6243C12.0298 19.7295 12.1922 19.745 12.3097 19.6592C13.5507 18.7587 19.9906 14.0842 19.9906 14.0842"
        stroke="#003E4C"
        strokeWidth="0.997638"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PaperAirplane
